import React, { useEffect } from 'react'
import { processSilentRenew } from 'redux-oidc'

const SilentCallback: React.FC = () => {
  useEffect(() => {
    processSilentRenew()
  })

  return (
    <html>
      <head></head>
      <body></body>
    </html>
  )
}

export default SilentCallback
